// StreakPopup.js
import React from 'react';
import './streakPopup.css';

const StreakPopup = ({ isOpen, onClose, day, completed }) => {
  if (!isOpen) return null;

  return (
    <div className="strike-popup-overlay">
      <div className="strike-popup-content">
        <button className="strike-popup-close" onClick={onClose}>✖</button>
        <h3>{day} - {completed ? "Zi completată!" : "Zi necompletată"}</h3>
        {completed ? (
          <p>✅ Ai rezolvat toate exercițiile în această zi. Streak-ul continuă! 🔥</p>
        ) : (
          <p>⚠️ Nu ai completat ziua. Încearcă să revii mâine pentru a menține streak-ul!</p>
        )}
      </div>
    </div>
  );
};

export default StreakPopup;
